import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./App.css";
import Invitation from "./Screens/Invitation/Invitation";
import Email from "./Screens/Email/Email";
import InvitationPreview from "./Screens/Invitation/InvitationPreview";
import NoInvitation from "./Screens/NoInvitation/NoInvitation";
import TablePage from "./Screens/Invitation/TablePage";

function App() {
  const router = createBrowserRouter([
    {
      path: "/invitation/:invitationId/:guestId",
      element: <Invitation />,
      children: [
        {
          path: "invitation/:invitationId/:guestId",
          element: <Invitation />,
        },
      ],
    },
    {
      path: "/invitation/:invitationId/:guestId/table",
      element: <TablePage />,
      children: [
        {
          path: "invitation/:invitationId/:guestId/table",
          element: <TablePage />,
        },
      ],
    },
    {
      path: "/preview/:invitationId",
      element: <InvitationPreview />,
      children: [
        {
          path: "preview/:invitationId",
          element: <InvitationPreview />,
        },
      ],
    },
    {
      path: "/email/template",
      element: <Email />,
      children: [
        {
          path: "/email/template",
          element: <Email />,
        },
      ],
    },
  ]);

  return (
    <div
      className="App"
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <RouterProvider router={router} fallbackElement={<NoInvitation />} />
    </div>
  );
}

export default App;
